// extracted by mini-css-extract-plugin
export var notStarted = "typing-code-block-module--notStarted--1XDwC";
export var playButton = "typing-code-block-module--playButton--2padt";
export var playText = "typing-code-block-module--playText--2OF1W";
export var replayButton = "typing-code-block-module--replayButton--22os4";
export var typingCodeBlock = "typing-code-block-module--typingCodeBlock--2jo0o";